module.exports = __webpack_public_path__ + "static/_/src/config/gridViewConfigs/gameInterface/sound/02//f01.mp3";